import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTabs from '../../components/CustomTabs';
import CustomToggle from '../../components/CustomToggle';
import Header from '../../components/Header';
import LoadNaturesSettingsRow from '../../components/tables/admin/internal/LoadNaturesSettingsRow';
import TrucksSettingsRow from '../../components/tables/admin/vehicles/TrucksSettingsRow';
import TrucksTypesSettingsRow from '../../components/tables/admin/vehicles/TrucksTypesSettingsRow';
import VehiclesTable from '../../components/tables/admin/vehicles/VehiclesTable';
import VehiclesTypesTable from '../../components/tables/admin/vehicles/VehiclesTypesTable';
import { useAuth } from '../../hooks/useAuth';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { localStorageKeys, permissionLevels } from '../../utils/enums';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';
import { usePageTitle } from '../../hooks/usePageTitle';
import ToggleLine from '../../components/ToggleLine';

const VehiclesAdminPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.ADMINVEHCILES) || '0'));
    const [withUsageCount, setWithUsageCount] = useState<boolean>(false);

    const { t } = useTranslation();
    const { user } = useAuth();
    usePageTitle(capitalizeFirstLetter(t('vehicles')));

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.ADMINVEHCILES, newValue.toString());
    };

    return (
        <div className="fx-c h-100">
            <Header
                title={t('admin')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('vehicles')) }]}
                subTitle={capitalizeFirstLetter(t('vehicles'))}
                isDateVisible={false}
            >
                {user?.profileId.permsLevel === permissionLevels.ADMIN && (
                    <ToggleLine title={capitalizeFirstLetter(t('showUsage'))} checked={withUsageCount} onChange={setWithUsageCount} />
                )}
            </Header>
            <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabLabels={[t('lightVehciles'), t('lightVehcilesTypes'), t('trucks'), t('trucksTypes')]}
            />
            {selectedTab == 0 && <VehiclesTable withUsageCount={withUsageCount} />}
            {selectedTab == 1 && <VehiclesTypesTable withUsageCount={withUsageCount} />}
            {selectedTab == 2 && <TrucksSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 3 && <TrucksTypesSettingsRow withUsageCount={withUsageCount} />}
            
        </div>
    );
};

export default VehiclesAdminPage;
